import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  public appPages: AppPage[] = [
    {
      title: 'Food Tracker',
      url: '/food-tracker',
      icon: 'nutrition'
    },
    {
      title: 'Meine Rezepte',
      url: '/recipes',
      icon: 'book'
    },
    {
      title: 'Einstellungen',
      url: '/settings',
      icon: 'person-circle'
    }
  ];

  private history: string[] = [];
  public readonly defaultPage: number = 0;
  private readonly defaultPageRoute: string = '/food-tracker';
  public requestedPageRoute = '';
  public selectedIndex = 0;

  constructor(private router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
        console.log(this.history);
      }
    });
  }

  back(): void {
    this.history.pop();
    if (this.history.length > 0 && this.history[this.history.length - 1] !== '/landing') {
      this.setIndex(this.history[this.history.length - 1]);
      this.router.navigate([this.history[this.history.length - 1]]).then();
    } else {
      this.goToDefaultPage(true);
    }
  }

  getLastLocation(): string {
    if (this.history.length > 1) {
      return this.history[this.history.length - 2];
    } else {
      return;
    }
  }

  goToDefaultPage(force: boolean = false): void {
    if (this.requestedPageRoute !== '' && !force){
      this.router.navigate([this.requestedPageRoute]).then();
      this.setIndex(this.requestedPageRoute);
      this.requestedPageRoute = '';
      return;
    }
    this.router.navigate([this.defaultPageRoute]).then();
    this.selectedIndex = this.defaultPage;
  }

  private setIndex(route: string): void {
    if (!route) { return; }
    this.selectedIndex = this.appPages.findIndex(appPage => route.startsWith(appPage.url));
  }
}

interface AppPage {
  title: string;
  url: string;
  icon: string;
}
